<template>
	<div ref="content" class="content background2">
		<div ref="search">
			<SearchList ref="searchContent" :searchList="searchList"></SearchList>
		</div>
		<div ref="btnList">
			<BtnList ref="btn" :btnList="btnList"></BtnList>
		</div>
		<div ref="tableList" class="list" :style="{'padding-top':paddingTop}">
			<List ref="list" :tableData="tableData" :tableList="tableList" :pageSize="pageSize" :pageNo="pageNo"
				@parentMethod="getInfo"></List>
		</div>
		<div ref="page" class="page">
			<Page ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
				@parentMethod="search"></Page>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/common/list.css"
	import SearchList from "@/components/list/searchList";
	import BtnList from "@/components/list/btnList";
	import List from "@/components/list/list";
	import Page from "@/components/common/page";
	import User from "@/assets/js/system/user.js";
	import CommonJs from "@/assets/js/common/common.js";
	export default {
		name: 'list',
		components: {
			List,
			SearchList,
			BtnList,
			Page
		},
		data() {
			const $this = this;
			return {
				paddingTop: 0,
				searchList: [{
					searchLabel: '时间类型',
					searchValue: '',
					searchType: 1,
					searchTermList: [],
					searchWidth: '25%',
					searchBr: false,
					column: 'timeType',
				}, ],
				btnList: [],
				tableList: [{
					column: 'startTime',
					title: '开始时间',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'endTime',
					title: '结束时间',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'timeType',
					title: '时间类型',
					headerAlign: 'center',
					align: 'center',
					termList: [],
					width: '20%'
				}],
				tableData: [],
				tableInfo: {},
				pageCount: 0,
				pageSize: 0,
				pageNo: 1,
				timeTypeList: [],
			}
		},
		methods: {
			queryArea() {},
			async getTimeTypeList() {
				await CommonJs.getDict('时间类型').then((response) => {
					const data = response.data;
					if (data.code == 1) {
						let list = [];
						data.data.forEach(function(item, index) {
							var param = {};
							param.id = item.rank;
							param.name = item.value;
							list.push(param);
						})
						this.searchList[0].searchTermList = list;
						this.btnList[0].columnList[2].columnTermList = list;
						this.btnList[1].columnList[2].columnTermList = list;
						this.tableList[2].termList = list;
						this.timeTypeList = list;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getTimeList(param) {
				User.getTimeList(param).then((response) => {
					const data = response.data;
					this.pageCount = data.data.total;
					this.pageNo = data.data.current;
					this.$refs['pageModel'].setCurrent(this.pageNo);
					this.tableData = data.data.records;
				}).catch((response) => {
					console.log(response)
				})
			},
			search(param) {
				var dataParam = this.$refs.searchContent.getSearchParam();
				var newParam = Object.assign(param, dataParam);
				this.getTimeList(newParam);
			},
			getWindowHeight() {
				let height = '';
				height = this.$refs.tableList.clientHeight - (this.$refs.search.clientHeight + this.$refs.btnList
					.clientHeight +
					20) - 60;
				this.height = height;
				if (height > 550) {
					let line = parseInt((height - 10) / 50);
					if (this.pageSize != line) {
						this.pageSize = line;
					}
				} else {
					if (this.pageSize != 10) {
						this.pageSize = 10;
					}
				}
				this.search({
					pageNo: 1,
					pageSize: this.pageSize
				});
			},
			getInfo(info) {
				this.tableInfo = info;
			}
		},
		created() {
			this.menuList = this.$store.getters.getMenuPermission;
			const $this = this;
			if (this.menuList.indexOf("CD_641") != -1) {
				this.btnList.push({
					btnLabel: '新增',
					btnType: 1,
					btnPosition: 'left',
					title: '新增',
					columnList: [{
							columnLabel: '开始时间',
							value: '',
							column: 'startTime',
							columnType: 7,
							placeholder: '请选择开始时间',
						},
						{
							columnLabel: '结束时间',
							value: '',
							column: 'endTime',
							columnType: 7,
							placeholder: '请选择结束时间',
						}, {
							columnLabel: '时间类型',
							value: '',
							column: 'timeType',
							columnType: 1,
							placeholder: '请选择',
							columnTermList: [],
						},
					],
					btnClick: function(tip) {
						tip();
						$this.btnList[0].columnList.forEach(function(item, index) {
							item.value = '';
						})
					},
					btnFun: function(tip, info) {
						if (info.startTime == "") {
							$this.utils.tipsAlert('请选择开始时间');
							return
						}
						if (info.endTime == "") {
							$this.utils.tipsAlert('请选择结束时间');
							return
						}
						if (info.timeType == "") {
							$this.utils.tipsAlert('请选择时间类型');
							return
						}
						/*User.addTime(info).then((response) => {
						  const data = response.data;
						  if (data.code == 1) {
						    $this.utils.saveAlert();
						    $this.search({
						      pageNo: 1,
						      pageSize: $this.pageSize
						    });
						    $this.btnList[0].columnList.forEach(function(item, index) {
						      item.value = '';
						    })
						    tip()
						  } else {
						    $this.utils.tipsAlert(data.message);
						  }
						}).catch((response) => {
						  console.log(response)
						})*/
					}
				});
			}
			if (this.menuList.indexOf("CD_642") != -1) {
				this.btnList.push({
					btnLabel: '编辑',
					btnType: 4,
					btnPosition: 'left',
					title: '编辑',
					columnList: [{
							columnLabel: '开始时间',
							value: '',
							column: 'startTime',
							columnType: 7,
							placeholder: '请选择开始时间',
						},
						{
							columnLabel: '结束时间',
							value: '',
							column: 'endTime',
							columnType: 7,
							placeholder: '请选择结束时间',
						}, {
							columnLabel: '时间类型',
							value: '',
							column: 'timeType',
							columnType: 1,
							placeholder: '请选择',
							columnTermList: [],
						},
					],
					btnClick: function(tip) {
						if (Object.keys($this.tableInfo).length > 0) {
							tip();
							$this.btnList[1].columnList.forEach(function(item, index) {
								item.value = $this.tableInfo[item.column];
							})
						} else {
							$this.utils.tipsAlert('请选择数据');
						}
					},
					btnFun: function(tip, info) {
						if (info.startTime == "") {
							$this.utils.tipsAlert('请选择开始时间');
							return
						}
						if (info.endTime == "") {
							$this.utils.tipsAlert('请选择结束时间');
							return
						}
						if (info.timeType == "") {
							$this.utils.tipsAlert('请选择时间类型');
							return
						}
						info.id = $this.tableInfo.id
						User.updataTime(info).then((response) => {
							const data = response.data;
							if (data.code == 1) {
								$this.utils.editAlert();
								$this.search({
									pageNo: 1,
									pageSize: $this.pageSize
								});
								tip()
							} else {
								$this.utils.tipsAlert(data.message);
							}
						}).catch((response) => {
							console.log(response)
						})
					}
				});
			}
			if (this.menuList.indexOf("CD_643") != -1) {
				this.btnList.push({
					btnLabel: '删除',
					btnType: 0,
					btnPosition: 'left',
					btnFun: function() {
						if (Object.keys($this.tableInfo).length > 0) {
							$this.$confirm('是否删除这个时间?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								var info = [$this.tableInfo.id]
								User.delTime(info).then((response) => {
									const data = response.data;
									if (data.code == 1) {
										$this.utils.delAlert();
									} else {
										$this.utils.tipsAlert(data.message);
									}
									$this.search({
										pageNo: 1,
										pageSize: $this.pageSize
									});
								}).catch((response) => {
									console.log(response)
								})
							});
						} else {
							$this.utils.tipsAlert('请选择数据');
						}
					}
				});
			}
			this.btnList.push({
				btnLabel: '查询',
				btnType: 3,
				btnPosition: 'right',
				btnFun: function() {
					$this.search({
						pageNo: 1,
						pageSize: $this.pageSize
					});
				},
			});
		},
		mounted() {
			this.paddingTop = (this.$refs.search.clientHeight + this.$refs.btnList.clientHeight + 20) + 'px';
			this.getTimeTypeList();
			this.getWindowHeight();
			window.onresize = () => {
				this.getWindowHeight();
				this.$refs.list.getHeight();
			}
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/system/time.vue